export default "__VITE_ASSET__BwPMBqs8__"